import React from 'react';
import Icon from '../../../components/AppIcon';

const DownloadProgress = ({ progress = 0, stage = "preparing", isComplete = false }) => {
  const stages = [
    { id: "preparing", label: "Preparing files", icon: "FileSearch" },
    { id: "compressing", label: "Compressing ZIP", icon: "Archive" },
    { id: "uploading", label: "Uploading to storage", icon: "Upload" },
    { id: "finalizing", label: "Finalizing download", icon: "CheckCircle2" }
  ];

  const getCurrentStageIndex = () => {
    return stages?.findIndex(s => s?.id === stage);
  };

  const currentIndex = getCurrentStageIndex();

  return (
    <div className="bg-card rounded-lg p-4 md:p-6 border border-border">
      <div className="mb-4 md:mb-6">
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-base md:text-lg font-semibold">
            {isComplete ? "Download Ready!" : "Preparing Download"}
          </h3>
          <span className="text-sm md:text-base font-medium text-primary">
            {Math.round(progress)}%
          </span>
        </div>
        <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
          <div
            className="h-full bg-primary transition-all duration-500 ease-out"
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>
      <div className="space-y-2 md:space-y-3">
        {stages?.map((stageItem, index) => {
          const isActive = index === currentIndex;
          const isCompleted = index < currentIndex || isComplete;

          return (
            <div
              key={stageItem?.id}
              className={`flex items-center gap-3 p-2 md:p-3 rounded-md transition-all duration-300 ${
                isActive ? 'bg-primary text-primary-foreground' : 
                isCompleted ? 'bg-success text-success-foreground': 'bg-muted text-muted-foreground'
              }`}
            >
              <div className="flex-shrink-0">
                {isCompleted ? (
                  <Icon name="Check" size={18} />
                ) : isActive ? (
                  <div className="animate-spin">
                    <Icon name="Loader2" size={18} />
                  </div>
                ) : (
                  <Icon name={stageItem?.icon} size={18} />
                )}
              </div>
              <span className="text-sm md:text-base font-medium">{stageItem?.label}</span>
            </div>
          );
        })}
      </div>
      {isComplete && (
        <div className="mt-4 md:mt-6 p-3 md:p-4 bg-success rounded-md flex items-center gap-3">
          <Icon name="CheckCircle2" size={20} className="text-success-foreground flex-shrink-0" />
          <p className="text-sm md:text-base text-success-foreground">
            Your project is ready for download!
          </p>
        </div>
      )}
    </div>
  );
};

export default DownloadProgress;